export enum InquiryErrors {
  NotAvailable = "NOT_AVAILABLE",
  Unknown = "UNKNOWN",
}
